export enum BoxesFields {
  type = "type",
  length = "length",
  width = "width",
  height = "height",
  material = "material",
  mainColor = "mainColor",
  numberOfPrintColors = "numberOfPrintColors",
  designFile = "designFile",
  typeFile = "typeFile",
  amountPcs = "amountPcs",
}
